module.exports = __webpack_public_path__ + "img/FaceAI-mockup1.0661383f.png";